import React from "react";
import styles from "../ritualpraxis.module.css";
import Head from "next/head";
import Image from "next/image";

import Image1 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image1.webp";
import Image2 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image2.webp";
import saffron from "../../../public/image/ritual-praxis-and-instructions/page-13/saffron_img.webp";
import honey from "../../../public/image/ritual-praxis-and-instructions/page-13/honey_img.webp";
import sunflower from "../../../public/image/ritual-praxis-and-instructions/page-13/sunflower_img.webp";
import sun_stone from "../../../public/image/ritual-praxis-and-instructions/page-13/sun_stone_img.webp";
import citrine from "../../../public/image/ritual-praxis-and-instructions/page-13/citrine_img.webp";
import topaz from "../../../public/image/ritual-praxis-and-instructions/page-13/topaz_img.webp";
import apollo from "../../../public/image/ritual-praxis-and-instructions/page-13/apollo_img.webp";
import sūrya_nārāyaṇa from "../../../public/image/ritual-praxis-and-instructions/page-13/sūrya_nārāyaṇa_img.webp";
import ra from "../../../public/image/ritual-praxis-and-instructions/page-13/ra_img.webp";
import Image4 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image4.webp";
import milk from "../../../public/image/ritual-praxis-and-instructions/page-13/milk_img.webp";
import rice from "../../../public/image/ritual-praxis-and-instructions/page-13/rice_img.webp";
import jasmine from "../../../public/image/ritual-praxis-and-instructions/page-13/jasmine_img.webp";
import moonstone from "../../../public/image/ritual-praxis-and-instructions/page-13/moonstone_img.webp";
import selenite from "../../../public/image/ritual-praxis-and-instructions/page-13/selenite_img.webp";
import pearl from "../../../public/image/ritual-praxis-and-instructions/page-13/pearl_img.webp";
import chandra from "../../../public/image/ritual-praxis-and-instructions/page-13/chandra_img.webp";
import khonsu from "../../../public/image/ritual-praxis-and-instructions/page-13/khonsu_img.webp";
import diana from "../../../public/image/ritual-praxis-and-instructions/page-13/diana_img.webp";
import Image6 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image6.webp";
import fresh_mint from "../../../public/image/ritual-praxis-and-instructions/page-13/fresh_mint_img.webp";
import anise from "../../../public/image/ritual-praxis-and-instructions/page-13/anise_img.webp";
import paper_ink from "../../../public/image/ritual-praxis-and-instructions/page-13/paper_ink_img.webp";
import carnelian from "../../../public/image/ritual-praxis-and-instructions/page-13/carnelian_img.webp";
import emerald from "../../../public/image/ritual-praxis-and-instructions/page-13/emerald_img.webp";
import aventurine from "../../../public/image/ritual-praxis-and-instructions/page-13/aventurine_img.webp";
import hermes from "../../../public/image/ritual-praxis-and-instructions/page-13/hermes_img.webp";
import budha from "../../../public/image/ritual-praxis-and-instructions/page-13/budha_img.webp";
import nabû from "../../../public/image/ritual-praxis-and-instructions/page-13/nabû_img.webp";
import Image8 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image8.webp";
import roses from "../../../public/image/ritual-praxis-and-instructions/page-13/roses_img.webp";
import sweet_wine from "../../../public/image/ritual-praxis-and-instructions/page-13/sweet_wine_img.webp";
import honeyed_cakes from "../../../public/image/ritual-praxis-and-instructions/page-13/honeyed_cakes_img.webp";
import emerald_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/emerald_part2_img.webp";
import malachite from "../../../public/image/ritual-praxis-and-instructions/page-13/malachite_img.webp";
import chrysoprase from "../../../public/image/ritual-praxis-and-instructions/page-13/chrysoprase_img.webp";
import venus from "../../../public/image/ritual-praxis-and-instructions/page-13/venus_img.webp";
import lakṣmī from "../../../public/image/ritual-praxis-and-instructions/page-13/lakṣmī_img.webp";
import freyja from "../../../public/image/ritual-praxis-and-instructions/page-13/freyja_img.webp";
import Image10 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image10.webp";
import red_peppers from "../../../public/image/ritual-praxis-and-instructions/page-13/red_peppers_img.webp";
import pomegranate from "../../../public/image/ritual-praxis-and-instructions/page-13/pomegranate_img.webp";
import strong_red_wine from "../../../public/image/ritual-praxis-and-instructions/page-13/strong_red_wine_img.webp";
import red_jasper from "../../../public/image/ritual-praxis-and-instructions/page-13/red_jasper_img.webp";
import garnet from "../../../public/image/ritual-praxis-and-instructions/page-13/garnet_img.webp";
import hematite from "../../../public/image/ritual-praxis-and-instructions/page-13/hematite_img.webp";
import ares from "../../../public/image/ritual-praxis-and-instructions/page-13/ares_img.webp";
import skanda from "../../../public/image/ritual-praxis-and-instructions/page-13/skanda_img.webp";
import tyr from "../../../public/image/ritual-praxis-and-instructions/page-13/tyr_img.webp";
import Image12 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image12.webp";
import frankincense_cedar from "../../../public/image/ritual-praxis-and-instructions/page-13/frankincense_cedar_img.webp";
import saffron_cakes from "../../../public/image/ritual-praxis-and-instructions/page-13/saffron_cakes_img.webp";
import herbal_mead from "../../../public/image/ritual-praxis-and-instructions/page-13/herbal_mead_img.webp";
import lapis_lazuli from "../../../public/image/ritual-praxis-and-instructions/page-13/lapis_lazuli_img.webp";
import amethyst from "../../../public/image/ritual-praxis-and-instructions/page-13/amethyst_img.webp";
import sodalite from "../../../public/image/ritual-praxis-and-instructions/page-13/sodalite_img.webp";
import zeus from "../../../public/image/ritual-praxis-and-instructions/page-13/zeus_img.webp";
import marduk from "../../../public/image/ritual-praxis-and-instructions/page-13/marduk_img.webp";
import thor from "../../../public/image/ritual-praxis-and-instructions/page-13/thor_img.webp";
import Image14 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image14.webp";
import myrrh from "../../../public/image/ritual-praxis-and-instructions/page-13/myrrh_img.webp";
import cypress_ivy from "../../../public/image/ritual-praxis-and-instructions/page-13/cypress_ivy_img.webp";
import simple_water from "../../../public/image/ritual-praxis-and-instructions/page-13/simple_water_img.webp";
import onyx from "../../../public/image/ritual-praxis-and-instructions/page-13/onyx_img.webp";
import smoky from "../../../public/image/ritual-praxis-and-instructions/page-13/smoky_img.webp";
import quartz from "../../../public/image/ritual-praxis-and-instructions/page-13/quartz_img.webp";
import saturn from "../../../public/image/ritual-praxis-and-instructions/page-13/saturn_img.webp";
import ptah from "../../../public/image/ritual-praxis-and-instructions/page-13/ptah_img.webp";
import ninurta from "../../../public/image/ritual-praxis-and-instructions/page-13/ninurta_img.webp";
import Image16 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image16.webp";
import sudden_hymns from "../../../public/image/ritual-praxis-and-instructions/page-13/sudden_hymns_img.webp";
import avant_garde_music from "../../../public/image/ritual-praxis-and-instructions/page-13/avant_garde_music_img.webp";
import lightning_motif from "../../../public/image/ritual-praxis-and-instructions/page-13/lightning_motif_img.webp";
import labradorite from "../../../public/image/ritual-praxis-and-instructions/page-13/labradorite_img.webp";
import tektite from "../../../public/image/ritual-praxis-and-instructions/page-13/tektite_img.webp";
import aqua_aura_quartz from "../../../public/image/ritual-praxis-and-instructions/page-13/aqua_aura_quartz_img.webp";
import ouranos from "../../../public/image/ritual-praxis-and-instructions/page-13/ouranos_img.webp";
import prometheus from "../../../public/image/ritual-praxis-and-instructions/page-13/prometheus_img.webp";
import varuṇa from "../../../public/image/ritual-praxis-and-instructions/page-13/varuṇa_img.webp";
import Image18 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image18.webp";
import seawater_bowl from "../../../public/image/ritual-praxis-and-instructions/page-13/seawater_bowl_img.webp";
import blue_lotus from "../../../public/image/ritual-praxis-and-instructions/page-13/blue_lotus_img.webp";
import kelp from "../../../public/image/ritual-praxis-and-instructions/page-13/kelp_img.webp";
import larimar from "../../../public/image/ritual-praxis-and-instructions/page-13/larimar_img.webp";
import sea_opal from "../../../public/image/ritual-praxis-and-instructions/page-13/sea_opal_img.webp";
import lepidolite from "../../../public/image/ritual-praxis-and-instructions/page-13/lepidolite_img.webp";
import poseidon from "../../../public/image/ritual-praxis-and-instructions/page-13/poseidon_img.webp";
import varuṇa_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/varuṇa_part2_img.webp";
import manannán from "../../../public/image/ritual-praxis-and-instructions/page-13/manannán_img.webp";
import Image20 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image20.webp";
import dark_wine from "../../../public/image/ritual-praxis-and-instructions/page-13/dark_wine_img.webp";
import pomegranate_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/pomegranate_part2_img.webp";
import myrrh_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/myrrh_img.webp";
import obsidian from "../../../public/image/ritual-praxis-and-instructions/page-13/obsidian_img.webp";
import garnet_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/garnet_part2_img.webp";
import basalt from "../../../public/image/ritual-praxis-and-instructions/page-13/basalt_img.webp";
import hades from "../../../public/image/ritual-praxis-and-instructions/page-13/hades_img.webp";
import plouton from "../../../public/image/ritual-praxis-and-instructions/page-13/plouton_img.webp";
import persephone from "../../../public/image/ritual-praxis-and-instructions/page-13/persephone_img.webp";
import Image22 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image22.webp";
import ginger from "../../../public/image/ritual-praxis-and-instructions/page-13/ginger_img.webp";
import iron_token from "../../../public/image/ritual-praxis-and-instructions/page-13/iron_token_img.webp";
import red_cloth from "../../../public/image/ritual-praxis-and-instructions/page-13/red_cloth_img.webp";
import red_jasper_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/red_jasper_part2_img.webp";
import carnelian_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/carnelian_part2_img.webp";
import garnet_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/garnet_part3_img.webp";
import ares_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/ares_part2_img.webp";
import skanda_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/skanda_part2_img.webp";
import athena_as_warrior from "../../../public/image/ritual-praxis-and-instructions/page-13/athena_as_warrior_img.webp";
import Image24 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image24.webp";
import roses_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/roses_part2_img.webp";
import emerald_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/emerald_part3_img.webp";
import jade from "../../../public/image/ritual-praxis-and-instructions/page-13/jade_img.webp";
import malachite_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/malachite_part2_img.webp";
import hathor from "../../../public/image/ritual-praxis-and-instructions/page-13/hathor_img.webp";
import lakṣmī_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/lakṣmī_part2_img.webp";
import freyr from "../../../public/image/ritual-praxis-and-instructions/page-13/freyr_img.webp";
import Image26 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image26.webp";
import quills from "../../../public/image/ritual-praxis-and-instructions/page-13/quills_img.webp";
import riddles from "../../../public/image/ritual-praxis-and-instructions/page-13/riddles_img.webp";
import agate from "../../../public/image/ritual-praxis-and-instructions/page-13/agate_img.webp";
import citrine_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/citrine_part2_img.webp";
import fluorite from "../../../public/image/ritual-praxis-and-instructions/page-13/fluorite_img.webp";
import hermes_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/hermes_part2_img.webp";
import sarasvatī from "../../../public/image/ritual-praxis-and-instructions/page-13/sarasvatī_img.webp";
import nabu from "../../../public/image/ritual-praxis-and-instructions/page-13/nabu_img.webp";
import Image28 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image28.webp";
import rice_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/rice_part2_img.webp";
import white_flowers from "../../../public/image/ritual-praxis-and-instructions/page-13/white_flowers_img.webp";
import home_baked_bread from "../../../public/image/ritual-praxis-and-instructions/page-13/home_baked_bread_img.webp";
import moonstone_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/moonstone_part2_img.webp";
import pearl_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/pearl_part2_img.webp";
import selenite_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/selenite_part2_img.webp";
import artemis from "../../../public/image/ritual-praxis-and-instructions/page-13/artemis_img.webp";
import isis from "../../../public/image/ritual-praxis-and-instructions/page-13/isis_img.webp";
import yemọja from "../../../public/image/ritual-praxis-and-instructions/page-13/yemọja_img.webp";
import Image30 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image30.webp";
import saffron_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/saffron_part2_img.webp";
import honey_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/honey_part2_img.webp";
import sunflowers from "../../../public/image/ritual-praxis-and-instructions/page-13/sunflowers_img.webp";
import sunstone from "../../../public/image/ritual-praxis-and-instructions/page-13/sunstone_img.webp";
import citrine_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/citrine_part3_img.webp";
import ruby from "../../../public/image/ritual-praxis-and-instructions/page-13/ruby_img.webp";
import apollo_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/apollo_part2_img.webp";
import sekhmet from "../../../public/image/ritual-praxis-and-instructions/page-13/sekhmet_img.webp";
import sūrya from "../../../public/image/ritual-praxis-and-instructions/page-13/sūrya_img.webp";
import Image32 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image32.webp";
import grains from "../../../public/image/ritual-praxis-and-instructions/page-13/grains_img.webp";
import herbs from "../../../public/image/ritual-praxis-and-instructions/page-13/herbs_img.webp";
import clean_water from "../../../public/image/ritual-praxis-and-instructions/page-13/clean_water_img.webp";
import sun_stone_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/sun_stone_part2_img.webp";
import citrine_part4 from "../../../public/image/ritual-praxis-and-instructions/page-13/citrine_part4_img.webp";
import topaz_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/topaz_part2_img.webp";
import demeter from "../../../public/image/ritual-praxis-and-instructions/page-13/demeter_img.webp";
import sarasvatī_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/sarasvatī_part2_img.webp";
import nisaba from "../../../public/image/ritual-praxis-and-instructions/page-13/nisaba_img.webp";
import Image34 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image34.webp";
import perfumes from "../../../public/image/ritual-praxis-and-instructions/page-13/perfumes_img.webp";
import rose_petals from "../../../public/image/ritual-praxis-and-instructions/page-13/rose_petals_img.webp";
import music_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/music_part2_img.webp";
import jade_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/jade_part2_img.webp";
import lapis from "../../../public/image/ritual-praxis-and-instructions/page-13/lapis_img.webp";
import rose_quartz from "../../../public/image/ritual-praxis-and-instructions/page-13/rose_quartz_img.webp";
import aphrodite from "../../../public/image/ritual-praxis-and-instructions/page-13/aphrodite_img.webp";
import themis_maat from "../../../public/image/ritual-praxis-and-instructions/page-13/themis_maat_img.webp";
import lakṣmī_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/lakṣmī_part3_img.webp";
import Image36 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image36.webp";
import myrrh_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/myrrh_part3_img.webp";
import pomegranate_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/pomegranate_part3_img.webp";
import black_candle from "../../../public/image/ritual-praxis-and-instructions/page-13/black_candle_img.webp";
import black_tourmaline from "../../../public/image/ritual-praxis-and-instructions/page-13/black_tourmaline_img.webp";
import kālī from "../../../public/image/ritual-praxis-and-instructions/page-13/kālī_img.webp";
import anubis from "../../../public/image/ritual-praxis-and-instructions/page-13/anubis_img.webp";
import ereshkigal from "../../../public/image/ritual-praxis-and-instructions/page-13/ereshkigal_img.webp";
import Image38 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image38.webp";
import frankincense from "../../../public/image/ritual-praxis-and-instructions/page-13/frankincense_img.webp";
import spiced_mead from "../../../public/image/ritual-praxis-and-instructions/page-13/spiced_mead_img.webp";
import arrow_symbol from "../../../public/image/ritual-praxis-and-instructions/page-13/arrow_symbol_img.webp";
import amethyst_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/amethyst_part2_img.webp";
import lapis_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/lapis_part2_img.webp";
import blue_topaz from "../../../public/image/ritual-praxis-and-instructions/page-13/blue_topaz_img.webp";
import jupiter from "../../../public/image/ritual-praxis-and-instructions/page-13/jupiter_img.webp";
import apollo_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/apollo_part3_img.webp";
import centaur_chiron from "../../../public/image/ritual-praxis-and-instructions/page-13/centaur_chiron_img.webp";
import Image40 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image40.webp";
import myrrh_part4 from "../../../public/image/ritual-praxis-and-instructions/page-13/myrrh_part4_img.webp";
import dark_bread from "../../../public/image/ritual-praxis-and-instructions/page-13/dark_bread_img.webp";
import mountain_stone from "../../../public/image/ritual-praxis-and-instructions/page-13/mountain_stone_img.webp";
import onyx_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/onyx_part2_img.webp";
import smoky_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/smoky_part2_img.webp";
import hematite_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/hematite_part2_img.webp";
import siva from "../../../public/image/ritual-praxis-and-instructions/page-13/siva_img.webp";
import pan from "../../../public/image/ritual-praxis-and-instructions/page-13/pan_img.webp";
import ninurta_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/ninurta_part2_img.webp";
import Image42 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image42.webp";
import clear_water_poured_from_amphora from "../../../public/image/ritual-praxis-and-instructions/page-13/clear_water_poured_from_amphora_img.webp";
import incense_of_camphor from "../../../public/image/ritual-praxis-and-instructions/page-13/incense_of_camphor_img.webp";
import innovative_hymn from "../../../public/image/ritual-praxis-and-instructions/page-13/innovative_hymn_img.webp";
import amethyst_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/amethyst_part3_img.webp";
import labradorit_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/labradorit_part2_img.webp";
import moldavite from "../../../public/image/ritual-praxis-and-instructions/page-13/moldavite_img.webp";
import prometheus_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/prometheus_part2_img.webp";
import varuṇa_part3 from "../../../public/image/ritual-praxis-and-instructions/page-13/varuṇa_part3_img.webp";
import enki from "../../../public/image/ritual-praxis-and-instructions/page-13/enki_img.webp";
import Image44 from "../../../public/image/ritual-praxis-and-instructions/page-13/chapter13_Image44.webp";
import blue_lotus_tea from "../../../public/image/ritual-praxis-and-instructions/page-13/blue_lotus_tea_img.webp";
import seawater_bowl_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/seawater_bowl_part2_img.webp";
import incense_of_benzoin from "../../../public/image/ritual-praxis-and-instructions/page-13/incense_of_benzoin_img.webp";
import aquamarine from "../../../public/image/ritual-praxis-and-instructions/page-13/aquamarine_img.webp";
import opal_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/opal_part2_img.webp";
import vishnu from "../../../public/image/ritual-praxis-and-instructions/page-13/vishnu_img.webp";
import nārāyaṇa_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/nārāyaṇa_part2_img.webp";
import poseidon_part2 from "../../../public/image/ritual-praxis-and-instructions/page-13/poseidon_part2_img.webp";

export default function Chapter_13() {
  return (
    <>
      <Head>
        <title>
          Chapter 13 | Ritual Praxis | School of Our Divine Infinite Being
        </title>
      </Head>

      <div className={`${styles.ritual_praxis_page_part1_main} ${styles.chapter13_main}`}>
        {/* ========== PART 1: DREAM THEURGY SECTION ========== */}

        {/* Orange Banner: Dream Theurgy */}
        <div className={styles.chapter13_part1_main}>
          <div className={styles.common_width}>
            <div className={styles.orange_heading_section}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>
                      Appendix V – Offerings, Stones, and Icons: A Quick Reference
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.blck_sec_common_width}>
            <div className={`${styles.blck1_main} ${styles.flex_direction_reverse}`}>
              <div className={styles.image_section}>
                <Image className={styles.c13_b1_img} src={Image1} alt="#" />
              </div>
              <div className={styles.content_section_main}>
                <div className={styles.content_section}>
                  <p>
                    Every offering, every stone, every image placed upon the
                    altar participates in the same cosmic grammar as the stars
                    above. Bread and wine, crystal and metal, statue and
                    flame—all are vessels through which the divine may recognize
                    its reflection in the human act.
                  </p>

                  <p>
                    This table is provided as a <span>practical guide:</span> a
                    quick reference for offerings, stones, and icons associated
                    with each planetary sphere and zodiacal presence. It is not
                    exhaustive nor rigid, but a framework through which the
                    theurgist may build their ritual temple with intelligence
                    and reverence.{" "}
                    <span>
                      Choose what resonates, what is available, and what speaks
                      with authenticity.
                    </span>
                  </p>

                  <p>
                    A stone becomes a talisman when consecrated. A statue
                    becomes an icon when invoked. A cup of wine becomes
                    sacrament when offered with intention. Matter responds to
                    spirit, and spirit delights in matter offered back to it.
                    Use this guide to harmonize your ritual space with the
                    heavens, to seat the gods upon their proper thrones, and to
                    ensure that every rite is conducted in resonance with the
                    cosmic order.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.chapter13_new_design_blck_main}>
              <div className={`${styles.blck1_main} ${styles.c13_blck2_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b2_img} src={Image2} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.green_heading_25}>
                      Planetary Spheres
                    </h4>

                    <p>
                      <b>
                        Sun <span>(Sol/Helios/Sūrya)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> frankincense resin, saffron,
                      honey, ripe citrus, golden flowers{" "}
                      <span>(marigold/sunflower), </span> clarified butter{" "}
                      <span>(ghee),</span> sweet wine, fresh bread.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> sunstone, citrine, amber, golden
                      topaz, ruby, heliodor.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Helios/Apollo; Sūrya–Nārāyaṇa;
                      Ra; Shamash; Mihr/Mithras ; Christ.{" "}
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck3_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={saffron} alt="Saffron" />
                        <h2>Saffron</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={honey} alt="Honey" />
                        <h2>Honey</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sunflower} alt="Sunflower" />
                        <h2>Sunflower</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={sun_stone} alt="Sun Stone" />
                        <h2>Sun Stone</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={citrine} alt="Citrine" />
                        <h2>Citrine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={topaz} alt="Topaz" />
                        <h2>Topaz</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={apollo} alt="Apollo" />
                        <h2>Apollo</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sūrya_nārāyaṇa} alt="Sūrya–Nārāyaṇa" />
                        <h2>Sūrya–Nārāyaṇa</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ra} alt="RA" />
                        <h2>RA</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck4_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b4_img} src={Image4} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Moon <span>(Luna/Selene/Chandra)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> milk, rice, coconut,
                      jasmine/lotus, white flowers, cucumber/melon, camphor,
                      silver bowl of water.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> moonstone, selenite, pearl, opal,
                      alabaster.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Selene/Artemis/Hecate;
                      Chandra; Khonsu; Diana; Manat.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck5_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={milk} alt="Milk" />
                        <h2>Milk</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={rice} alt="Rice" />
                        <h2>Rice</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={jasmine} alt="Jasmine" />
                        <h2>Jasmine</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={moonstone} alt="Moonstone" />
                        <h2>Moonstone</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={selenite} alt="Selenite" />
                        <h2>Selenite</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pearl} alt="Pearl" />
                        <h2>Pearl</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={chandra} alt="Chandra" />
                        <h2>Chandra</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={khonsu} alt="Khonsu" />
                        <h2>Khonsu</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={diana} alt="Diana" />
                        <h2>Diana</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck6_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b6_img} src={Image6} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Mercury <span>(Hermes/Budha)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> fresh mint, anise/fennel/dill,
                      quick-witted hymns/poems, paper & ink, winged
                      sandals/scroll talisman, light aromatic incense
                      (storax/benzoin).
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> agate{" "}
                      <span>(esp. moss/banded),</span> carnelian, emerald,
                      aventurine, fluorite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Hermes; Budha; Thoth; Nabû;
                      Odin <span>(as wanderer)</span>.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck7_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={fresh_mint} alt="Fresh Mint" />
                        <h2>Fresh Mint</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={anise} alt="Anise" />
                        <h2>Anise</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={paper_ink} alt="paper & ink" />
                        <h2>paper & ink</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={carnelian} alt="Carnelian" />
                        <h2>Carnelian</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={emerald} alt="Emerald" />
                        <h2>Emerald</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={aventurine} alt="Aventurine" />
                        <h2>Aventurine</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={hermes} alt="Hermes" />
                        <h2>Hermes</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={budha} alt="Budha" />
                        <h2>Budha</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={nabû} alt="Nabû" />
                        <h2>Nabû</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck8_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b8_img} src={Image8} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Venus <span>(Aphrodite/Śukra)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> roses, perfumes/attar, copper
                      vessels, sweet wine or mead, honeyed cakes, chocolate,
                      music.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> emerald, rose quartz, jade,
                      malachite, rhodonite, chrysoprase.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Aphrodite/Venus; Lakṣmī;
                      Hathor; Inanna/Ishtar; Freyja.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck9_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={roses} alt="Roses" />
                        <h2>Roses</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sweet_wine} alt="Sweet Wine" />
                        <h2>Sweet Wine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={honeyed_cakes} alt="Honeyed Cakes" />
                        <h2>Honeyed Cakes</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={emerald_part2} alt="Emerald" />
                        <h2>Emerald</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={malachite} alt="Malachite" />
                        <h2>Malachite</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={chrysoprase} alt="Chrysoprase" />
                        <h2>Chrysoprase</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={venus} alt="Venus" />
                        <h2>Venus</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lakṣmī} alt="Lakṣmī" />
                        <h2>Lakṣmī</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={freyja} alt="Freyja" />
                        <h2>Freyja</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck10_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b10_img} src={Image10} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Mars <span>(Ares/Maṅgala)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> red peppers/ginger, pomegranate,
                      iron nail (symbolic), strong red wine, clove/cinnamon,
                      martial hymns/drumming.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> red jasper, garnet, hematite,
                      bloodstone, pyrite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Ares/Mars; Skanda/Kārttikeya;
                      Sekhmet/Montu; Nergal; Tyr.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck11_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={red_peppers} alt="Red Peppers" />
                        <h2>Red Peppers</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pomegranate} alt="Pomegranate" />
                        <h2>Pomegranate</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={strong_red_wine} alt="Strong Red Wine" />
                        <h2>Strong Red Wine</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={red_jasper} alt="Red Jasper" />
                        <h2>Red Jasper</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={garnet} alt="Garnet" />
                        <h2>Garnet</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={hematite} alt="Hematite" />
                        <h2>Hematite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={ares} alt="Ares" />
                        <h2>Ares</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={skanda} alt="Skanda" />
                        <h2>Skanda</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={tyr} alt="Tyr" />
                        <h2>Tyr</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck12_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b12_img} src={Image12} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Jupiter <span>(Zeus/Bṛhaspati)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> frankincense + cedar, bay/oak
                      leaves, saffron cakes, sweet breads, herbal mead,
                      gratitude prayers/benedictions.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> lapis lazuli, amethyst, sapphire,
                      sodalite, blue topaz.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Zeus/Jupiter; Bṛhaspati;
                      Marduk; Amun; Thor <span>(as protector-giver)</span>.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck13_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image
                          src={frankincense_cedar}
                          alt="Frankincense + Cedar"
                        />
                        <h2>Frankincense + Cedar</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={saffron_cakes} alt="Saffron Cakes" />
                        <h2>Saffron Cakes</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={herbal_mead} alt="Herbal Mead" />
                        <h2>Herbal Mead</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={lapis_lazuli} alt="Lapis Lazuli" />
                        <h2>Lapis Lazuli</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={amethyst} alt="Amethyst" />
                        <h2>Amethyst</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sodalite} alt="Sodalite" />
                        <h2>Sodalite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={zeus} alt="ZEUS" />
                        <h2>ZEUS</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={marduk} alt="Marduk" />
                        <h2>Marduk</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={thor} alt="Thor" />
                        <h2>Thor</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck14_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b14_img} src={Image14} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>
                        Saturn <span>(Kronos/Śani)</span>
                      </b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> myrrh, cypress/ivy, dark bread +
                      salt, black sesame, simple water, oaths/vows.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> onyx, jet, black tourmaline,
                      obsidian, smoky quartz.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Kronos/Saturn; Śani; Ptah;
                      Ninurta; Hades <span>(as chthonic order)</span>.{" "}
                      <span>(as chthonic order)</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck15_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={myrrh} alt="Myrrh" />
                        <h2>Myrrh</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={cypress_ivy} alt="cypress/ivy" />
                        <h2>cypress/ivy</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={simple_water} alt="Simple Water" />
                        <h2>Simple Water</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={onyx} alt="ONYX" />
                        <h2>ONYX</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={smoky} alt="Smoky" />
                        <h2>Smoky</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={quartz} alt="Quartz" />
                        <h2>Quartz</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={saturn} alt="Saturn" />
                        <h2>Saturn</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ptah} alt="Ptah" />
                        <h2>Ptah</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ninurta} alt="Ninurta" />
                        <h2>Ninurta</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck16_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b16_img} src={Image16} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Uranus</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> electric-bright incense
                      (camphor/menthol), sudden hymns, avant-garde music,
                      lightning motif.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> labradorite, tektite, aqua aura
                      quartz, zircon.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Ouranos; Prometheus; Varuṇa{" "}
                      <span>(sky-law, cosmic ocean)</span>.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck17_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={sudden_hymns} alt="Sudden Hymns" />
                        <h2>Sudden Hymns</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image
                          src={avant_garde_music}
                          alt="Avant-Garde Music"
                        />
                        <h2>Avant-Garde Music</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lightning_motif} alt="Lightning Motif" />
                        <h2>Lightning Motif</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={labradorite} alt="Labradorite" />
                        <h2>Labradorite</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={tektite} alt="Tektite" />
                        <h2>Tektite</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={aqua_aura_quartz} alt="Aqua Aura Quartz" />
                        <h2>Aqua Aura Quartz</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={ouranos} alt="Ouranos" />
                        <h2>Ouranos</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={prometheus} alt="Prometheus" />
                        <h2>Prometheus</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={varuṇa} alt="Varuṇa" />
                        <h2>Varuṇa</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck18_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b18_img} src={Image18} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Neptune</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> seawater bowl, blue lotus/lotus
                      tea, sea salt, kelp, soft chants/drones.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> aquamarine, larimar, sea opal,
                      lepidolite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Poseidon; Varuṇa; Āpaḥ/river
                      goddesses; Manannán.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck19_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={seawater_bowl} alt="Seawater Bowl" />
                        <h2>Seawater Bowl</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={blue_lotus} alt="Blue Lotus" />
                        <h2>Blue Lotus</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={kelp} alt="Kelp" />
                        <h2>Kelp</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={larimar} alt="Larimar" />
                        <h2>Larimar</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sea_opal} alt="Sea Opal" />
                        <h2>Sea Opal</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lepidolite} alt="Lepidolite" />
                        <h2>Lepidolite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={poseidon} alt="Poseidon" />
                        <h2>Poseidon</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={varuṇa_part2} alt="Varuṇa" />
                        <h2>Varuṇa</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={manannán} alt="Manannán" />
                        <h2>Manannán</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck20_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b20_img} src={Image20} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Pluto</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> dark wine, pomegranate,
                      myrrh/storax, grave soil <span>(token),</span> keys/coin
                      for passage <span>(symbolic)</span>.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> obsidian, garnet, black garnet{" "}
                      <span>(melanite),</span> basalt.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Hades/Plouton/Persephone;
                      Yama/Kālī <span>(as chthonic liberator);</span>{" "}
                      Ereshkigal.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck21_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={dark_wine} alt="Dark Wine" />
                        <h2>Dark Wine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pomegranate_part2} alt="Pomegranate" />
                        <h2>Pomegranate</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={myrrh_part2} alt="Myrrh" />
                        <h2>Myrrh</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={obsidian} alt="Obsidian" />
                        <h2>Obsidian</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={garnet_part2} alt="Garnet" />
                        <h2>Garnet</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={basalt} alt="Basalt" />
                        <h2>Basalt</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={hades} alt="Hades" />
                        <h2>Hades</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={plouton} alt="Plouton" />
                        <h2>Plouton</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={persephone} alt="Persephone" />
                        <h2>Persephone</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.chapter13_part2_main}>
          <div className={styles.blck_sec_common_width}>
            <div className={styles.chapter13_new_design_blck_main}>
              <div className={`${styles.blck1_main} ${styles.c13_blck22_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b22_img} src={Image22} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <h4 className={styles.green_heading_25}>
                      Zodiacal Presences{" "}
                    </h4>

                    <p>
                      <b>Aries</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> chili/ginger, iron token, red
                      cloth, martial hymns.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> red jasper, carnelian, garnet.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Ares; Skanda; Athena as
                      warrior; Agni; Montu.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck23_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={ginger} alt="Ginger" />
                        <h2>Ginger</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={iron_token} alt="IRON TOKEN" />
                        <h2>IRON TOKEN</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={red_cloth} alt="Red Cloth" />
                        <h2>Red Cloth</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={red_jasper_part2} alt="Red Jasper" />
                        <h2>Red Jasper</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={carnelian_part2} alt="Carnelian" />
                        <h2>Carnelian</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={garnet_part3} alt="Garnet" />
                        <h2>Garnet</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={ares_part2} alt="ARES" />
                        <h2>ARES</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={skanda_part2} alt="Skanda" />
                        <h2>Skanda</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image
                          src={athena_as_warrior}
                          alt="Athena as Warrior"
                        />
                        <h2>Athena as Warrior</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck24_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b24_img} src={Image24} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Taurus</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> roses, cream/milk, honey, music,
                      sweet pastry, copper vessel.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> emerald, jade, malachite, rose
                      quartz.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Aphrodite{" "}
                      <span>(earthy aspect)</span>; Hathor; Lakṣmī; Freyr.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck25_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={roses_part2} alt="Roses" />
                        <h2>Roses</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={honey} alt="Honey" />
                        <h2>Honey</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={milk} alt="Milk" />
                        <h2>Milk</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={emerald_part3} alt="Emerald" />
                        <h2>Emerald</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={jade} alt="Jade" />
                        <h2>Jade</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={malachite_part2} alt="Malachite" />
                        <h2>Malachite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={hathor} alt="Hathor" />
                        <h2>Hathor</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lakṣmī_part2} alt="Lakṣmī" />
                        <h2>Lakṣmī</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={freyr} alt="Freyr" />
                        <h2>Freyr</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck26_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b26_img} src={Image26} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Gemini</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> quills/paper, anise/mint, riddles,
                      paired candles.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> agate <span>(twin bands),</span>{" "}
                      citrine, fluorite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Hermes; Sarasvatī; Odin{" "}
                      <span>(runes);</span> Nabu/Thoth.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck27_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={quills} alt="Quills" />
                        <h2>Quills</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={anise} alt="Anise" />
                        <h2>Anise</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={riddles} alt="Riddles" />
                        <h2>Riddles</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={agate} alt="Agate (twin bands)" />
                        <h2>Agate (twin bands)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={citrine_part2} alt="Citrine" />
                        <h2>Citrine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={fluorite} alt="Fluorite" />
                        <h2>Fluorite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={hermes_part2} alt="Hermes;" />
                        <h2>Hermes;</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sarasvatī} alt="Sarasvatī" />
                        <h2>Sarasvatī</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={nabu} alt="Nabu" />
                        <h2>Nabu</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck28_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b28_img} src={Image28} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Cancer</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> milk/rice, lunar water, white
                      flowers, home-baked bread.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> moonstone, pearl, selenite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Selene/Artemis; Pārvatī; Isis;
                      Yemọja.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck29_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={rice_part2} alt="Rice" />
                        <h2>Rice</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={white_flowers} alt="White Flowers" />
                        <h2>White Flowers</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={home_baked_bread} alt="Home-Baked Bread" />
                        <h2>Home-Baked Bread</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={moonstone_part2} alt="Moonstone" />
                        <h2>Moonstone</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pearl_part2} alt="Pearl" />
                        <h2>Pearl</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={selenite_part2} alt="Selenite" />
                        <h2>Selenite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={artemis} alt="Artemis" />
                        <h2>Artemis</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={isis} alt="Isis" />
                        <h2>Isis</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={yemọja} alt="Yemọja" />
                        <h2>Yemọja</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck30_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b30_img} src={Image30} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Leo</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> saffron, honey, gold cloth,
                      sunflowers, praise hymns.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> sunstone, citrine, ruby, amber.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Apollo/Helios; Sūrya; Sekhmet;
                      Narasiṁha.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck31_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={saffron_part2} alt="Saffron" />
                        <h2>Saffron</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={honey_part2} alt="Honey" />
                        <h2>Honey</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sunflowers} alt="Sunflowers" />
                        <h2>Sunflowers</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={sunstone} alt="Sunstone" />
                        <h2>Sunstone</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={citrine_part3} alt="Citrine" />
                        <h2>Citrine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ruby} alt="Ruby" />
                        <h2>Ruby</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={apollo_part2} alt="Apollo" />
                        <h2>Apollo</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sekhmet} alt="Sekhmet" />
                        <h2>Sekhmet</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={sūrya} alt="Sūrya" />
                        <h2>Sūrya</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck32_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b32_img} src={Image32} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Virgo</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> grains, herbs (sage/rosemary),
                      orderly altar, clean water.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> peridot, moss agate, amazonite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Demeter/Ceres; Sarasvatī
                      (order/learning); Nisaba.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck33_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={grains} alt="Grains" />
                        <h2>Grains</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={herbs} alt="Herbs(sage/rosemary)" />
                        <h2>Herbs(sage/rosemary)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={clean_water} alt="Clean Water" />
                        <h2>Clean Water</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={sun_stone_part2} alt="SUN STONE" />
                        <h2>SUN STONE</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={citrine_part4} alt="Citrine" />
                        <h2>Citrine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={topaz_part2} alt="TOPAZ" />
                        <h2>TOPAZ</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={demeter} alt="Demeter" />
                        <h2>Demeter</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image
                          src={sarasvatī_part2}
                          alt="Sarasvatī (order/learning)"
                        />
                        <h2>Sarasvatī (order/learning)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={nisaba} alt="Nisaba" />
                        <h2>Nisaba</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck34_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b34_img} src={Image34} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Libra</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> perfumes, rose petals, music,
                      balanced scales on altar.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> jade, lapis <span>(justice)</span>,
                      rose quartz.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Aphrodite <span>(airy)</span>,
                      Themis/Maʿat; Lakṣmī <span>(equipoise)</span>.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck35_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={perfumes} alt="Perfumes" />
                        <h2>Perfumes</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={rose_petals} alt="Rose Petals" />
                        <h2>Rose Petals</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={music_part2} alt="Music" />
                        <h2>Music</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={jade_part2} alt="Jade" />
                        <h2>Jade</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lapis} alt="Lapis (justice)" />
                        <h2>Lapis (justice)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={rose_quartz} alt="Rose Quartz" />
                        <h2>Rose Quartz</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={aphrodite} alt="Aphrodite (airy)" />
                        <h2>Aphrodite (airy)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={themis_maat} alt="Themis/Maʿat;" />
                        <h2>Themis/Maʿat;</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lakṣmī_part3} alt="Lakṣmī (equipoise)." />
                        <h2>Lakṣmī (equipoise).</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck36_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b36_img} src={Image36} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Scorpio</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> myrrh/storax, pomegranate, black
                      candle, transformation vows.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> obsidian, garnet, black tourmaline.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Kālī; Anubis; Hecate; Rudra;
                      Ereshkigal.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck37_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={myrrh_part3} alt="Myrrh" />
                        <h2>Myrrh</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pomegranate_part3} alt="Pomegranate" />
                        <h2>Pomegranate</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={black_candle} alt="Black Candle" />
                        <h2>BlaCk candle</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={obsidian} alt="Obsidian" />
                        <h2>Obsidian</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={garnet} alt="Garnet" />
                        <h2>Garnet</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={black_tourmaline} alt="Black Tourmaline" />
                        <h2>Black Tourmaline</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={kālī} alt="Kālī" />
                        <h2>Kālī</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={anubis} alt="Anubis" />
                        <h2>Anubis</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ereshkigal} alt="Ereshkigal" />
                        <h2>Ereshkigal</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck38_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b38_img} src={Image38} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Sagittarius</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> frankincense, cedar, spiced mead,
                      maps/books of wisdom, arrow symbol.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> amethyst, lapis, blue topaz.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Zeus/Jupiter; Bṛhaspati;
                      Apollo <span>(as archer);</span> Centaur Chiron.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck39_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={frankincense} alt="frankincense" />
                        <h2>frankincense</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={spiced_mead} alt="Spiced Mead" />
                        <h2>Spiced Mead</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={arrow_symbol} alt="Arrow Symbol" />
                        <h2>Arrow Symbol</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={amethyst_part2} alt="Amethyst" />
                        <h2>Amethyst</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={lapis_part2} alt="Lapis" />
                        <h2>Lapis</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={blue_topaz} alt="Blue Topaz" />
                        <h2>Blue Topaz</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={jupiter} alt="Jupiter" />
                        <h2>Jupiter</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={apollo_part3} alt="Apollo (as archer)" />
                        <h2>Apollo (as archer)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={centaur_chiron} alt="Centaur Chiron" />
                        <h2>Centaur Chiron</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck40_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b40_img} src={Image40} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Capricorn</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> myrrh, dark bread + salt, mountain
                      stone, vow tablet.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> onyx, smoky quartz, hematite.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Kronos/Saturn; Śiva{" "}
                      <span>(ascetic);</span> Pan; Ninurta.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck41_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={myrrh_part4} alt="Myrrh" />
                        <h2>Myrrh</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={dark_bread} alt="Dark Bread" />
                        <h2>Dark Bread</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={mountain_stone} alt="Mountain Stone" />
                        <h2>Mountain Stone</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={onyx_part2} alt="Onyx" />
                        <h2>Onyx</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={smoky_part2} alt="Smoky" />
                        <h2>Smoky</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={hematite_part2} alt="Hematite" />
                        <h2>Hematite</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={siva} alt="Śiva (ascetic)" />
                        <h2>Śiva (ascetic)</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={pan} alt="Pan" />
                        <h2>Pan</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={ninurta_part2} alt="Ninurta" />
                        <h2>Ninurta</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck42_main}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b42_img} src={Image42} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Aquarius</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> clear water poured from amphora,
                      incense of camphor, innovative hymn.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> amethyst, labradorite, garnet{" "}
                      <span>(Janus cusp),</span> moldavite{" "}
                      <span>(if desired)</span>.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Ganymede/Water-Bearer;
                      Prometheus; Varuṇa; Enki.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck43_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image
                          src={clear_water_poured_from_amphora}
                          alt="Clear Water Poured from Amphora"
                        />
                        <h2>Clear Water Poured from Amphora</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image
                          src={incense_of_camphor}
                          alt="Incense of Camphor"
                        />
                        <h2>Incense of Camphor</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={innovative_hymn} alt="Innovative Hymn" />
                        <h2>Innovative Hymn</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={amethyst_part3} alt="Amethyst" />
                        <h2>Amethyst</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={labradorit_part2} alt="Labradorite" />
                        <h2>Labradorite</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={moldavite} alt="Moldavite (if desired)." />
                        <h2>Moldavite (if desired).</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={prometheus_part2} alt="Prometheus" />
                        <h2>Prometheus</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={varuṇa_part3} alt="Varuṇa" />
                        <h2>Varuṇa</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={enki} alt="Enki." />
                        <h2>Enki.</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`${styles.blck1_main} ${styles.c13_blck44_main} ${styles.flex_direction_reverse}`}>
                <div className={styles.image_section}>
                  <Image className={styles.c13_b44_img} src={Image44} alt="#" />
                </div>
                <div className={styles.content_section_main}>
                  <div className={styles.content_section}>
                    <p>
                      <b>Pisces</b>
                    </p>

                    <p style={{ marginBottom: "0" }}>
                      <span>Offerings:</span> blue lotus tea, seawater bowl,
                      incense of benzoin, psalmic chant.
                    </p>
                    <p style={{ marginBottom: "0" }}>
                      <span>Stones:</span> aquamarine, amethyst, opal.
                    </p>
                    <p>
                      <span>Statues/Icons:</span> Vishnu/Nārāyaṇa; Poseidon;
                      Aphrodite Anadyomene; Avalokiteśvara.
                    </p>
                  </div>
                </div>
              </div>

              <div className={`${styles.c13_black_box_main} ${styles.c13_blck45_main}`}>
                <div className={styles.c13_black_box_sub}>
                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Offerings</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={blue_lotus_tea} alt="Blue Lotus Tea" />
                        <h2>Blue Lotus Tea</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={seawater_bowl_part2} alt="Seawater Bowl" />
                        <h2>Seawater Bowl</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image
                          src={incense_of_benzoin}
                          alt="Incense of Benzoin"
                        />
                        <h2>Incense of Benzoin</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Stones</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={aquamarine} alt="Aquamarine" />
                        <h2>Aquamarine</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={amethyst} alt="Amethyst" />
                        <h2>Amethyst</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={opal_part2} alt="Opal" />
                        <h2>Opal</h2>
                      </div>
                    </div>
                  </div>

                  <div className={styles.c13_black_sub_cont_box}>
                    <h3 className={styles.yellow_heading}>Statues/Icons</h3>

                    <div className={styles.c13_black_sub_cont_box_wrpr}>
                      <div className={styles.image_sec_main}>
                        <Image src={vishnu} alt="Vishnu" />
                        <h2>Vishnu</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={nārāyaṇa_part2} alt="Nārāyaṇa" />
                        <h2>Nārāyaṇa</h2>
                      </div>

                      <div className={styles.image_sec_main}>
                        <Image src={poseidon_part2} alt="Poseidon." />
                        <h2>Poseidon.</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
